import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import MemberLogin from '@/pages/member/MemberLogin.vue'
import Home from '@/pages/member/Home.vue'
import UserDetail from '@/pages/member/UserDetail.vue'
import Conference from '@/pages/member/Conference.vue'
import Qualifications from '@/pages/member/Qualifications.vue'
import Meetings from '@/pages/member/Meetings.vue'
import Positions from '@/pages/member/Positions.vue'
import Officers from '@/pages/member/Officers.vue'
import AnnualFees from '@/pages/member/AnnualFees.vue'
import EtcPayments from '@/pages/member/EtcPayments.vue'
import QualificationPayments from '@/pages/member/QualificationPayments.vue'
import Store from '@/store/member'
import Payment from '@/pages/member/Payment.vue'
import Receipt from '@/pages/member/Receipt.vue'
import Invoice from '@/pages/member/Invoice.vue'
import CreditCardAdd from '@/pages/member/PaymentCardAdd.vue'
import ChangePassword from '@/pages/member/ChangePassword.vue'
import NotFound from '@/components/NotFound.vue'
import ConferenceInfoDetail from '@/pages/member/ConferenceInfoDetail.vue'
import MeetingDetail from '@/pages/member/MeetingDetail.vue'
import PositionDetail from '@/pages/member/PositionDetail.vue'
import PositionMeetingDetail from '@/pages/member/PositionMeetingDetail.vue'
import OfficerMeetingDetail from '@/pages/member/OfficerMeetingDetail.vue'
import OfficerDetail from '@/pages/member/OfficerDetail.vue'
import AdminInfoDetail from '@/pages/member/AdminInfoDetail.vue'
import MemberForgetPassword from '@/pages/member/MemberForgetPassword.vue'
import MemberSettingPassword from '@/pages/member/MemberSettingPassword.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/member',
    name: 'Home',
    meta: { title: 'Home' },
    component: Home,
  },
  {
    path: '/member/user/detail',
    name: 'UserDetail',
    meta: { title: '会員情報' },
    component: UserDetail,
  },
  {
    path: '/member/user/password',
    name: 'ChangePassword',
    meta: { title: 'パスワード変更' },
    component: ChangePassword,
  },
  {
    path: '/member/conference',
    name: 'ConferenceDetail',
    meta: { title: 'organization情報' },
    component: Conference,
  },
  {
    path: '/member/qualifications',
    name: 'Qualifications',
    meta: { title: '資格・認定情報' },
    component: Qualifications,
  },
  {
    path: '/member/meetings',
    name: 'Meetings',
    meta: { title: 'organization・セミナー一覧' },
    component: Meetings,
  },
  {
    path: '/member/meetings/:id',
    name: 'MeetingDetail',
    meta: { title: 'organization・セミナー詳細' },
    component: MeetingDetail,
  },
  {
    path: '/member/meetings/:id/count',
    name: 'MeetingDetail2',
    meta: { title: 'organization・セミナー詳細' },
    component: MeetingDetail,
  },
  {
    path: '/member/positions',
    name: 'Positions',
    meta: { title: '委員会一覧' },
    component: Positions,
  },
  {
    path: '/member/positions/:id',
    name: 'PositionDetail',
    meta: { title: '委員会詳細' },
    component: PositionDetail,
  },
  {
    path: '/member/positions/meetings/:id',
    name: 'PositionMeetingDetail',
    meta: { title: '委員会開催詳細' },
    component: PositionMeetingDetail,
  },
  {
    path: '/member/officers',
    name: 'Officers',
    meta: { title: '理事・役員会一覧' },
    component: Officers,
  },
  {
    path: '/member/officers/:id',
    name: 'OfficerDetail',
    meta: { title: '理事・役員会詳細' },
    component: OfficerDetail,
  },
  {
    path: '/member/officers/meetings/:id',
    name: 'OfficerMeetingDetail',
    meta: { title: '理事・役員会開催詳細' },
    component: OfficerMeetingDetail,
  },
  {
    path: '/member/payments/annualFees',
    name: 'AnnualFees',
    meta: { title: '年会費一覧' },
    component: AnnualFees,
  },
  {
    path: '/member/payments/annualFees/:id',
    name: 'AnnualFeePayment',
    meta: { title: '決済' },
    component: Payment,
  },
  {
    path: '/member/payments/annualFees/:id/receipt',
    name: 'AnnualFeesReceipt',
    meta: { title: '領収書' },
    component: Receipt,
  },
  {
    path: '/member/payments/annualFees/:id/invoice',
    name: 'AnnualFeesInvoice',
    meta: { title: '請求書' },
    component: Invoice,
  },
  {
    path: '/member/payments/etcs',
    name: 'EtcPayments',
    meta: { title: 'その他入金一覧' },
    component: EtcPayments,
  },
  {
    path: '/member/payments/etcs/:id',
    name: 'EtcPayment',
    meta: { title: '決済' },
    component: Payment,
  },
  {
    path: '/member/payments/etcs/:id/receipt',
    name: 'EtcPaymentsReceipt',
    meta: { title: '領収書' },
    component: Receipt,
  },
  {
    path: '/member/payments/etcs/:id/invoice',
    name: 'EtcPaymentsInvoice',
    meta: { title: '請求書' },
    component: Invoice,
  },
  {
    path: '/member/payments/qualifications',
    name: 'QualificationPayments',
    meta: { title: '資格・認定入金一覧' },
    component: QualificationPayments,
  },
  {
    path: '/member/payments/qualifications/:id',
    name: 'QualificationPayment',
    meta: { title: '決済' },
    component: Payment,
  },
  {
    path: '/member/payments/qualifications/:id/receipt',
    name: 'QualificationPaymentsReceipt',
    meta: { title: '領収書' },
    component: Receipt,
  },
  {
    path: '/member/payments/qualifications/:id/invoice',
    name: 'QualificationPaymentsInvoice',
    meta: { title: '請求書' },
    component: Invoice,
  },
  {
    path: '/member/conference/notifications/:id',
    name: 'ConferenceInfoDetail',
    meta: { title: 'organizationからのお知らせ詳細' },
    component: ConferenceInfoDetail,
  },
  {
    path: '/member/admin/notifications/:id',
    name: 'AdminInfoDetail',
    meta: { title: '運営からのお知らせ詳細' },
    component: AdminInfoDetail,
  },
  {
    path: '/member/creditCard',
    name: 'creditCard',
    meta: { title: 'クレジットカード登録' },
    component: CreditCardAdd,
  },
  {
    path: '/member/login',
    name: 'Login',
    meta: { title: 'ログイン', layout: 'none', isPublic: true },
    component: MemberLogin,
  },
  {
    path: '/member/forgetPassword',
    name: 'MemberForgetPassword',
    meta: { title: 'パスワード再設定', layout: 'none', isPublic: true },
    component: MemberForgetPassword,
  },
  {
    path: '/member/settingPassword',
    name: 'MemberSettingPassword',
    meta: { title: 'パスワード設定', layout: 'none', isPublic: true },
    component: MemberSettingPassword,
  },
  {
    path: '/member/invitation',
    name: 'MemberInvitationSettingPassword',
    meta: { title: 'パスワード設定', layout: 'none', isPublic: true },
    component: MemberSettingPassword,
  },
  {
    path: '/member/*',
    name: 'NotFound',
    meta: { title: 'ページが見つかりません', isPublic: true },
    component: NotFound,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(async (to, from, next) => {
  Store.commit('updatePreRoute', from)
  try {
    await Store.dispatch('getProfile')
  } catch (e) {
    /* empty statement */
  }
  if (to.matched.some((page) => page.meta.isPublic) || Store.getters.isAuthenticated) {
    next()
  } else if (router.currentRoute.path !== '/member/login') {
    await Store.dispatch('logout')
  }
})

export default router
